<div class="row text-center info-card">
  <div class="col-12 my-2">
    <i [ngClass]="'ph ' + icon"></i>
  </div>
  <h5 class="mb-2">
    {{ title || "" }}
  </h5>
  <p>{{ text }}</p>
</div>
